import { useEffect, useState } from "react";
import { BookOpen, ChevronRight } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";

export function LessonCard({
  id,
  onClick,
  name: nameProp,
}: {
  id: number;
  onClick: () => void;
  name?: string | null;
}) {
  const [lessonName, setLessonName] = useState<string | null>(nameProp ?? null);
  const [loading, setLoading] = useState(nameProp === undefined);

  useEffect(() => {
    if (nameProp !== undefined) return;
    const load = async () => {
      try {
        const r = await fetch(`/api/internal/admin/lessons/${id}/name`);
        if (!r.ok) throw new Error(`${r.status}`);
        const data: { name: string | null } = await r.json();
        setLessonName(data.name);
      } catch {
        // show ID only on error
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, nameProp]);

  return (
    <button
      onClick={onClick}
      className="w-full text-left rounded-xl border bg-card shadow-sm px-5 py-4 flex items-center gap-4 hover:bg-accent/50 transition-colors group"
    >
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-600/10 text-blue-700">
        <BookOpen className="size-5" />
      </div>
      <div className="flex-1 min-w-0">
        {loading ? (
          <Skeleton className="h-4 w-40" />
        ) : (
          <p className="font-medium text-sm text-foreground truncate">
            {lessonName ?? `Lesson ${id}`}
          </p>
        )}
        {!loading && (
          <p className="text-xs text-muted-foreground mt-0.5">ID: {id}</p>
        )}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <Badge variant="secondary" className="text-xs">
          ID: {id}
        </Badge>
        <ChevronRight className="size-4 text-muted-foreground group-hover:text-foreground transition-colors" />
      </div>
    </button>
  );
}
